// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1aLrH","label":"Labeled_label__2sXXC","divider":"Labeled_divider__2ucND"};